import { prepareRuntime } from './appMount';

async function boot() {
  await prepareRuntime('boot');
  await import('./bootloader');
}

boot().catch((error) => console.error('[SimBobTerminalUI] boot failed', error));
